import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import ComercioNombre from './ComercioNombre';
import { fmtARS } from '../lib/money';
import '../styles/Regalos.css';
import { DELIVERY, DELIVERY_SRCSET } from '../lib/imagenes';

export default function RegalarModal({ match, onClose, onError }) {
  const [comercios, setComercios] = useState(null);
  const [selId, setSelId] = useState(null);
  const [mensaje, setMensaje] = useState('');
  const [paying, setPaying] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const puedeEnviar = user?.plan === 'mate' || user?.plan === 'premium';

  useEffect(() => {
    if (!puedeEnviar) return;
    api.regalosCatalogo()
      .then(d => setComercios(d.comercios || []))
      .catch(e => { setComercios([]); onError(e.message || 'Error cargando el catálogo.'); });
  }, [onError, puedeEnviar]);

  const productos = (comercios || []).flatMap(c => c.productos || []);
  const sel = productos.find(p => p.id === selId);

  const pagar = async () => {
    if (!sel || paying) return;
    setPaying(true);
    try {
      const r = await api.crearRegalo({ matchId: match.matchId, productoId: sel.id, mensaje: mensaje.trim() });
      window.location.href = r.initPoint;
    } catch (e) {
      onError(e.message || 'No pudimos iniciar el pago.');
      setPaying(false);
    }
  };

  if (!puedeEnviar) return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal regalar-modal" onClick={e => e.stopPropagation()}>
        <img src={DELIVERY} srcSet={DELIVERY_SRCSET} sizes="140px" alt="Cupido Delivery" className="cupido-delivery-logo cupido-delivery-logo--modal" />
        <p className="regalo-note" style={{ marginBottom: 20 }}>
          Mandale flores, bombones o un desayuno a {match.partner?.name} desde comercios de San Juan.
          Cupido Delivery está incluido en los planes Mate y Premium.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button className="btn btn-outline" onClick={onClose}>Ahora no</button>
          <button className="btn btn-primary" onClick={() => navigate('/planes')}>Ver planes</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal regalar-modal" onClick={e => e.stopPropagation()}>
        <img src={DELIVERY} srcSet={DELIVERY_SRCSET} sizes="140px" alt="Cupido Delivery" className="cupido-delivery-logo cupido-delivery-logo--modal" />
        <h2 style={{ fontFamily: 'var(--font-display)', marginBottom: 12 }}>🎁 Regalale algo a {match.partner?.name}</h2>
        <p className="regalo-note" style={{ marginBottom: 16 }}>
          Tu conexión elige si lo acepta y carga su dirección. Vos nunca ves su dirección. Si lo rechaza, se te devuelve el dinero.
        </p>

        {comercios === null ? (
          <p style={{ color: 'var(--texto-muted)', padding: 20, textAlign: 'center' }}>Cargando...</p>
        ) : comercios.length === 0 ? (
          <p className="regalos-empty">En este momento no hay comercios abiertos. Probá más tarde.</p>
        ) : (
          comercios.map(c => (
            <div key={c.id} className="regalar-comercio">
              <ComercioNombre comercio={c} />
              {c.descripcion && <div className="regalar-producto-desc" style={{ marginBottom: 4 }}>{c.descripcion}</div>}
              <div className="comercio-zona-info">
                {c.abierto_hasta && <>🟢 Abierto hasta las {c.abierto_hasta}</>}
                {c.abierto_hasta && c.zona && ' · '}
                {c.zona && <>📍 Entrega hasta {c.zona.radio_km} km de su local</>}
              </div>
              <div className="regalar-productos">
                {(c.productos || []).map(p => (
                  <button key={p.id} type="button"
                    className={`regalar-producto ${selId === p.id ? 'selected' : ''}`}
                    onClick={() => setSelId(p.id)}>
                    {p.foto_path && <img src={p.foto_path} alt={p.nombre} />}
                    <span className="regalar-producto-nombre">{p.nombre}</span>
                    {p.descripcion && <span className="regalar-producto-desc">{p.descripcion}</span>}
                    <span className="regalar-producto-precio">{fmtARS(p.precio)}</span>
                    {p.envio > 0 && <span className="regalar-producto-desc">Incluye envío</span>}
                  </button>
                ))}
              </div>
            </div>
          ))
        )}

        {comercios && comercios.length > 0 && (
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Mensaje (opcional)</label>
            <textarea className="form-input" rows={3} maxLength={200} value={mensaje}
              onChange={e => setMensaje(e.target.value)} placeholder="Escribile unas palabras..." />
            <span className="regalo-note">{mensaje.length}/200</span>
          </div>
        )}

        {comercios && comercios.length > 0 && (
          <p className="regalo-note" style={{ marginBottom: 16 }}>
            ⚠️ Cupido con Mate no se hace responsable de los envíos: cada comercio hace la entrega por su cuenta (PedidosYa, Uber u otro medio) y es responsable de que el regalo llegue.
            Cada comercio entrega solo dentro de su zona: si tu conexión lo recibe fuera de ella, no va a poder aceptarlo y se te devuelve el dinero. La factura la emite el comercio.
          </p>
        )}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
          {comercios && comercios.length > 0 && (
            <button className="btn btn-primary" disabled={!sel || paying} onClick={pagar}>
              {paying ? 'Redirigiendo...' : sel ? `Pagar ${fmtARS(sel.precio)} con MercadoPago` : 'Elegí un regalo'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
